// react
import React, {
  Fragment,
  useEffect,
  useReducer,
  useState,
  useMemo,
  useRef,
} from 'react';

// styles
import styles from './index.module.scss';
// components
import { NavHeader } from '../../../components/navHeader/index';
import { Message } from '../../../components/message/index';
import { Input } from '../../../components/inputs/InputField';
// circular progress
import CircularProgress from '@mui/material/CircularProgress';
// libraries FormData
import FormData from 'form-data';
import imageCompression from 'browser-image-compression';
// reducer
import {
  dashboardStatesInitialState,
  dashboardStatesReducer,
} from './indexReducer';
// MUI
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
// router
import { useNavigate } from 'react-router-dom';
// redux
import { useSelector } from 'react-redux';
// services
import { completeStudentDataService } from '../../../services/userService';
import { getTourismProgramsService } from '../../../services/universityStructureService';

/***************************************************************************/
/* Name : StudentDataEnter React Component */
/***************************************************************************/
const StudentDataEnter = React.memo(() => {
  const navigate = useNavigate();
  // reducer
  const [dashboardStates, dispatchDashboardStates] = useReducer(
    dashboardStatesReducer,
    dashboardStatesInitialState
  );
  // redux

  const [studentData, setStudentData] = useState(
    useSelector((state) => state.ui.studentData)
  );
  const [studentObj, setStudentObj] = useState(
    useSelector((state) => state.ui.studentObj)
  );
  const [compressOptiopns, setCompressOptiopns] = useState({
    maxSizeMB: 0.5,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  });
  const [frontIdCard, setFrontIdCard] = useState(null);
  const [frontIdCardState, setFrontIdCardState] = useState(false); // to show loading when compressing the image
  const [backIdCard, setBackIdCard] = useState(null);
  const [backIdCardState, setBackIdCardState] = useState(false); // to show loading when compressing the image
  const [birthCertificate, setBirthCertificate] = useState(null);
  const [birthCertificateState, setBirthCertificateState] = useState(false); // to show loading when compressing the image
  const [personalPhoto, setPersonalPhoto] = useState(null);
  const [personalPhotoState, setPersonalPhotoState] = useState(false); // to show loading when compressing the image
  const [secondarySchoolCertificate, setSecondarySchoolCertificate] =
    useState(null);
  const [secondarySchoolCertificateState, setSecondarySchoolCertificateState] =
    useState(false); // to show loading when compressing the image
  const [nominationCard, setNominationCard] = useState(null);
  const [nominationCardState, setNominationCardState] = useState(false); // to show loading when compressing the image
  const [tourismPrograms, setTourismPrograms] = useState([]);
  const [program1, setProgram1] = useState('');
  const [program2, setProgram2] = useState('');
  const [program3, setProgram3] = useState('');
  const [isTourism, setIsTourism] = useState(false);
  const [isSocial, setIsSocial] = useState(false);
  const id = useSelector((state) => state.ui.studentID);
  //
  const studentNameEnRef = useRef(); //1
  const secondPhoneNumberRef = useRef(); //2
  const addressRef = useRef(); //3
  const homeTelRef = useRef(); //4
  const emailRef = useRef(); //5
  const programRef1 = useRef(); //6
  const programRef2 = useRef(); //7
  const programRef3 = useRef(); //8
  const qualificationRef = useRef(); //9
  const yearPart1Ref = useRef(); //10
  const yearPart2Ref = useRef(); //11
  // father
  const fatherNameRef = useRef(); //12
  const fatherJobRef = useRef(); //13
  const fatherQualificationRef = useRef(); //14
  // master
  const masterNameRef = useRef(); //15
  const masterQualificationRef = useRef(); //16
  const masterJobRef = useRef(); //17
  // grade
  const totalGradeRef = useRef(); //18
  const percentageRef = useRef(); //19
  // Social
  const cityRef = useRef(); //20
  const brothersNumRef = useRef(); //21
  const brothersMaleNumRef = useRef(); //22
  const brothersFemaleNumRef = useRef(); //23
  const brothersOrderRef = useRef(); //24
  const incomeRef = useRef(); //25
  const motherNameRef = useRef(); //26
  const motherNationalityRef = useRef(); //27
  const motherJobRef = useRef(); //28
  const motherMobileRef = useRef(); //29
  const fatherNationalityRef = useRef(); //30
  const fatherMobileRef = useRef(); //30

  // useMemo to give the array without selected programRef2 and programRef3 aswell
  const tourismPrograms1 = useMemo(() => {
    return tourismPrograms.filter((el) => el !== program2 && el !== program3);
  }, [tourismPrograms, program2, program3]);

  const tourismPrograms2 = useMemo(() => {
    return tourismPrograms.filter((el) => el !== program1 && el !== program3);
  }, [tourismPrograms, program1, program3]);

  const tourismPrograms3 = useMemo(() => {
    return tourismPrograms.filter((el) => el !== program1 && el !== program2);
  }, [tourismPrograms, program1, program2]);

  // get id
  /******************************************************************/
  /* useEffect */
  /******************************************************************/
  useEffect(() => {
    (async () => {
      // check if studentData is empty
      if (studentData.length === 0) {
        navigate('/');
      } else {
        fillFields();
        if (
          [
            'كلية السياحة والفنادق',
            'كلية السياحة والفنادق تعليم تبادلى',
          ].includes(studentObj.college)
        ) {
          setIsTourism(true);
          const response = await getTourismProgramsService(studentObj.college);
          if (response.status === 'success') {
            setTourismPrograms(response.data);
          } else {
            dispatchDashboardStates({
              type: 'ERROR',
              errorMessage: response.message,
            });
          }
        }
        if (studentObj.college === 'كلية الخدمة الاجتماعية') setIsSocial(true);
      }
    })();
  }, []);
  useEffect(() => {
    if (isSocial || isTourism) {
      fillFields();
    }
  }, [isSocial, isTourism]);
  // snackbar state
  const handleCloseSnackbar = () => {
    dispatchDashboardStates({ type: 'CLEAR' });
  };
  /******************************************************************/
  /* fill fields */
  /******************************************************************/
  const fillFields = () => {
    // englishName
    studentNameEnRef.current.setInputValue(studentObj?.studentNameEn || '');
    // secondPhoneNumber
    secondPhoneNumberRef.current.setInputValue(studentObj.phoneNumber);
    // city
    addressRef.current.setInputValue(studentObj.address);
    // homeTel
    homeTelRef.current.setInputValue(studentObj.homeTel);
    // email
    emailRef.current.setInputValue(studentObj.email);
    // program
    if (isTourism) {
      programRef1.current.value = studentObj?.program1 || '';
      programRef2.current.value = studentObj?.program2 || '';
      programRef3.current.value = studentObj?.program3 || '';
    }
    // Social
    if (isSocial) {
      // city
      cityRef.current.setInputValue(studentObj?.city);
      // brothersNum
      brothersNumRef.current.setInputValue(studentObj.brothersNum);
      // brothersMaleNum
      brothersMaleNumRef.current.setInputValue(studentObj.brothersMaleNum);
      // brothersFemaleNum
      brothersFemaleNumRef.current.setInputValue(studentObj.brothersFemaleNum);
      // brothersOrder
      brothersOrderRef.current.setInputValue(studentObj.brothersOrder);
      // income
      incomeRef.current.setInputValue(studentObj.income);
      // motherName
      motherNameRef.current.setInputValue(studentObj.motherName);
      // motherNationality
      motherNationalityRef.current.setInputValue(studentObj.motherNationality);
      // motherJob
      motherJobRef.current.setInputValue(studentObj.motherJob);
      // motherMobile
      motherMobileRef.current.setInputValue(studentObj.motherMobile);
      // fatherNationality
      fatherNationalityRef.current.setInputValue(studentObj.fatherNationality);
      // fatherMobile
      fatherMobileRef.current.setInputValue(studentObj.fatherMobile);
    }
    // year
    // split the year
    if (
      studentObj.qualificationYear !== '' &&
      studentObj.qualificationYear !== undefined
    ) {
      const yearArr = studentObj.qualificationYear.split('/');
      yearPart1Ref.current.setInputValue(yearArr[0]);
      yearPart2Ref.current.setInputValue(yearArr[1]);
    }
    qualificationRef.current.setInputValue(studentObj.qualification);
    // totalGrade
    totalGradeRef.current.setInputValue(studentObj.totalGrade);
    // percentage
    percentageRef.current.setInputValue(studentObj.percentage);
    // fatherName
    fatherNameRef.current.setInputValue(studentObj.fatherName);
    // fatherJob
    fatherJobRef.current.setInputValue(studentObj.fatherJob);
    // fatherQualification
    fatherQualificationRef.current.setInputValue(
      studentObj.fatherQualification
    );
    // masterName
    masterNameRef.current.setInputValue(studentObj.masterName);
    // masterJob
    masterJobRef.current.setInputValue(studentObj.masterJob);
    // masterQualification
    masterQualificationRef.current.setInputValue(
      studentObj.masterQualification
    );
    // photos
    if (studentObj.isComplete) {
      setFrontIdCard(studentObj.frontIdCard);
      setBackIdCard(studentObj.backIdCard);
      setBirthCertificate(studentObj.birthCertificate);
      setPersonalPhoto(studentObj.personalPhoto);
      setSecondarySchoolCertificate(studentObj.secondarySchoolCertificate);
      setNominationCard(studentObj.nominationCard);
    }
  };

  /******************************************************************/
  /* validate */
  /******************************************************************/
  const validate = () => {
    // studentNameEn
    if (studentNameEnRef.current.getInputValue().trim() === '') {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال الاسم باللغة الانجليزية رباعى',
      });
      // activate error
      studentNameEnRef.current.activeError();
      return false;
    } else {
      // deactivate error
      studentNameEnRef.current.clearError();
    }
    // Social
    if (isSocial) {
      // city
      if (cityRef.current.getInputValue().trim() === '') {
        dispatchDashboardStates({
          type: 'ERROR',
          errorMessage: 'برجاء ادخال المدينة / المركز',
        });
        // activate error
        cityRef.current.activeError();
        return false;
      } else {
        // deactivate error
        cityRef.current.clearError();
      }
      // brothersNum
      if (brothersNumRef.current.getInputValue().trim() === '') {
        dispatchDashboardStates({
          type: 'ERROR',
          errorMessage: 'برجاء ادخال عدد الاخوة',
        });
        // activate error
        brothersNumRef.current.activeError();
        return false;
      } else {
        // deactivate error
        brothersNumRef.current.clearError();
      }
      // brothersMaleNum
      if (brothersMaleNumRef.current.getInputValue().trim() === '') {
        dispatchDashboardStates({
          type: 'ERROR',
          errorMessage: 'برجاء ادخال عدد الذكور',
        });
        // activate error
        brothersMaleNumRef.current.activeError();
        return false;
      } else {
        // deactivate error
        brothersMaleNumRef.current.clearError();
      }
      // brothersFemaleNum
      if (brothersFemaleNumRef.current.getInputValue().trim() === '') {
        dispatchDashboardStates({
          type: 'ERROR',
          errorMessage: 'برجاء ادخال عدد الاناث',
        });
        // activate error
        brothersFemaleNumRef.current.activeError();
        return false;
      } else {
        // deactivate error
        brothersFemaleNumRef.current.clearError();
      }
      // brothersOrder
      if (brothersOrderRef.current.getInputValue().trim() === '') {
        dispatchDashboardStates({
          type: 'ERROR',
          errorMessage: 'برجاء ادخال ترتيبك بين الاخوة',
        });
        // activate error
        brothersOrderRef.current.activeError();
        return false;
      } else {
        // deactivate error
        brothersOrderRef.current.clearError();
      }
      // income
      if (incomeRef.current.getInputValue().trim() === '') {
        dispatchDashboardStates({
          type: 'ERROR',
          errorMessage: 'برجاء ادخال الدخل الشهري للأسرة',
        });
        // activate error
        incomeRef.current.activeError();
        return false;
      } else {
        // deactivate error
        incomeRef.current.clearError();
      }
      // motherName
      if (motherNameRef.current.getInputValue().trim() === '') {
        dispatchDashboardStates({
          type: 'ERROR',
          errorMessage: 'برجاء ادخال اسم الام',
        });
        // activate error
        motherNameRef.current.activeError();
        return false;
      } else {
        // deactivate error
        motherNameRef.current.clearError();
      }
      // motherNationality
      if (motherNationalityRef.current.getInputValue().trim() === '') {
        dispatchDashboardStates({
          type: 'ERROR',
          errorMessage: 'برجاء ادخال الجنسية',
        });
        // activate error
        motherNationalityRef.current.activeError();
        return false;
      } else {
        // deactivate error
        motherNationalityRef.current.clearError();
      }
      // motherJob
      if (motherJobRef.current.getInputValue().trim() === '') {
        dispatchDashboardStates({
          type: 'ERROR',
          errorMessage: 'برجاء ادخال الوظيفة',
        });
        // activate error
        motherJobRef.current.activeError();
        return false;
      } else {
        // deactivate error
        motherJobRef.current.clearError();
      }
      // motherMobile
      if (motherMobileRef.current.getInputValue().trim() === '') {
        dispatchDashboardStates({
          type: 'ERROR',
          errorMessage: 'برجاء ادخال الموبيل',
        });
        // activate error
        motherMobileRef.current.activeError();
        return false;
      } else {
        // deactivate error
        motherMobileRef.current.clearError();
      }
      // fatherNationality
      if (fatherNationalityRef.current.getInputValue().trim() === '') {
        dispatchDashboardStates({
          type: 'ERROR',
          errorMessage: 'برجاء ادخال الجنسية',
        });
        // activate error
        fatherNationalityRef.current.activeError();
        return false;
      } else {
        // deactivate error
        fatherNationalityRef.current.clearError();
      }
      // fatherMobile
      if (fatherMobileRef.current.getInputValue().trim() === '') {
        dispatchDashboardStates({
          type: 'ERROR',
          errorMessage: 'برجاء ادخال الموبيل',
        });
        // activate error
        fatherMobileRef.current.activeError();
        return false;
      } else {
        // deactivate error
        fatherMobileRef.current.clearError();
      }
    }
    // secondPhoneNumber
    if (secondPhoneNumberRef.current.getInputValue().trim() === '') {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال رقم موبيل',
      });
      // activate error
      secondPhoneNumberRef.current.activeError();
      return false;
    } else {
      // deactivate error
      secondPhoneNumberRef.current.clearError();
    }
    // homeTel
    if (homeTelRef.current.getInputValue().trim() === '') {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال رقم تليفون المنزل',
      });
      // activate error
      homeTelRef.current.activeError();
      return false;
    } else {
      // deactivate error
      homeTelRef.current.clearError();
    }
    // city
    if (addressRef.current.getInputValue().trim() === '') {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال العنوان ',
      });
      // activate error
      addressRef.current.activeError();
      return false;
    } else {
      // deactivate error
      addressRef.current.clearError();
    }
    // email
    if (emailRef.current.getInputValue().trim() === '') {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال البريد الالكتروني',
      });
      // activate error
      emailRef.current.activeError();
      return false;
    } else {
      // deactivate error
      emailRef.current.clearError();
    }
    if (emailRef.current.getInputValue().trim() === '') {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال البريد الالكتروني',
      });
      // activate error
      emailRef.current.activeError();
      return false;
    } else {
      // deactivate error
      emailRef.current.clearError();
    }
    // program
    if (isTourism) {
      if (program1.trim() === '') {
        dispatchDashboardStates({
          type: 'ERROR',
          errorMessage: 'برجاء اختيار البرنامج الاول',
        });
        return false;
      }
      if (program2.trim() === '') {
        dispatchDashboardStates({
          type: 'ERROR',
          errorMessage: 'برجاء اختيار البرنامج الثانى',
        });
        return false;
      }
      if (program3.trim() === '') {
        dispatchDashboardStates({
          type: 'ERROR',
          errorMessage: 'برجاء اختيار البرنامج الثالث',
        });
        // activate error
        return false;
      }
    }
    // qualification
    if (qualificationRef.current.getInputValue().trim() === '') {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال المؤهل الدراسي',
      });
      // activate error
      qualificationRef.current.activeError();
      return false;
    } else {
      // deactivate error
      qualificationRef.current.clearError();
    }

    // year
    if (
      yearPart1Ref.current.getInputValue().trim() === '' ||
      yearPart2Ref.current.getInputValue().trim() === ''
    ) {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال سنة الحصول على المؤهل ',
      });
      // activate error
      yearPart1Ref.current.activeError();
      yearPart2Ref.current.activeError();
      return false;
    } else {
      // deactivate error
      yearPart1Ref.current.clearError();
      yearPart2Ref.current.clearError();
    }
    // totalGrade
    if (
      totalGradeRef.current.getInputValue() == '0' &&
      totalGradeRef.current.getInputValue().trim() !== ''
    ) {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال  المجموع الكلي',
      });
      // activate error
      totalGradeRef.current.activeError();
      return false;
    } else {
      // deactivate error
      totalGradeRef.current.clearError();
    }
    // percentage
    if (
      percentageRef.current.getInputValue() == '0' &&
      totalGradeRef.current.getInputValue().trim() !== ''
    ) {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال  النسبة المئوية',
      });
      // activate error
      percentageRef.current.activeError();
      return false;
    } else {
      // deactivate error
      percentageRef.current.clearError();
    }

    // masterName
    if (masterNameRef.current.getInputValue().trim() === '') {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال اسم ولي الامر',
      });
      // activate error
      masterNameRef.current.activeError();
      return false;
    } else {
      // deactivate error
      masterNameRef.current.clearError();
    }
    // masterJob
    if (masterJobRef.current.getInputValue().trim() === '') {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال الوظيفة لولي الامر',
      });
      // activate error
      masterJobRef.current.activeError();
      return false;
    } else {
      // deactivate error
      masterJobRef.current.clearError();
    }
    // masterQualification
    if (masterQualificationRef.current.getInputValue().trim() === '') {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال المؤهل الرئيسي لولي الامر',
      });
      // activate error
      masterQualificationRef.current.activeError();
      return false;
    } else {
      // deactivate error
      masterQualificationRef.current.clearError();
    }
    // fatherName
    if (fatherNameRef.current.getInputValue().trim() === '') {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال اسم الاب',
      });
      // activate error
      fatherNameRef.current.activeError();
      return false;
    } else {
      // deactivate error
      fatherNameRef.current.clearError();
    }
    // fatherJob
    if (fatherJobRef.current.getInputValue().trim() === '') {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال الوظيفة للأب',
      });
      // activate error
      fatherJobRef.current.activeError();
      return false;
    } else {
      // deactivate error
      fatherJobRef.current.clearError();
    }
    // fatherQualification
    if (fatherQualificationRef.current.getInputValue().trim() === '') {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال المؤهل الرئيسي للأب',
      });
      // activate error
      fatherQualificationRef.current.activeError();
      return false;
    } else {
      // deactivate error
      fatherQualificationRef.current.clearError();
    }
    // photos
    // frontIdCard
    if (frontIdCard === null) {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال صورة البطاقة من الامام',
      });
      return false;
    }
    // backIdCard
    if (backIdCard === null) {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال صورة البطاقة من الخلف',
      });
      return false;
    }
    // birthCertificate
    if (birthCertificate === null) {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال صورة شهادة الميلاد',
      });
      return false;
    }
    // personalPhoto
    if (personalPhoto === null) {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال صورة شخصية',
      });
      return false;
    }
    // secondarySchoolCertificate
    if (secondarySchoolCertificate === null) {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال صورة شهادة الثانوية العامة',
      });
      return false;
    }
    // nominationCard
    if (nominationCard === null) {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: 'برجاء ادخال صورة  بطاقة الترشيح',
      });
      return false;
    }
    return true;
  };
  /******************************************************************/
  /* enterDataHandler */
  /******************************************************************/
  const enterDataHandler = async (e) => {
    e.preventDefault();
    // validate
    dispatchDashboardStates({ type: 'PENDING' });
    const isValid = validate();

    // validate
    if (isValid) {
      // collect data in formData
      const formData = new FormData();
      formData.append(
        'studentNameEn',
        studentNameEnRef.current.getInputValue()
      ); //1
      formData.append(
        'phoneNumber',
        secondPhoneNumberRef.current.getInputValue()
      ); //2
      formData.append('address', addressRef.current.getInputValue()); //3
      formData.append('homeTel', homeTelRef.current.getInputValue()); //4
      formData.append('email', emailRef.current.getInputValue()); //5

      if (isTourism) {
        if (programRef1.current.value !== '') {
          formData.append('program1', programRef1.current.value); //6
        }
        if (programRef2.current.value !== '') {
          formData.append('program2', programRef2.current.value); //7
        }
        if (programRef3.current.value !== '') {
          formData.append('program3', programRef3.current.value); //8
        }
      }
      formData.append(
        'qualification',
        qualificationRef.current.getInputValue()
      ); //9
      formData.append(
        'qualificationYear',
        `${yearPart1Ref.current.getInputValue()}/${yearPart2Ref.current.getInputValue()}`
      ); //10
      formData.append('totalGrade', totalGradeRef.current.getInputValue()); //11
      formData.append('percentage', percentageRef.current.getInputValue()); //12

      formData.append('fatherName', fatherNameRef.current.getInputValue()); //13
      formData.append('fatherJob', fatherJobRef.current.getInputValue()); //14
      formData.append(
        'fatherQualification',
        fatherQualificationRef.current.getInputValue()
      ); //15

      formData.append('masterName', masterNameRef.current.getInputValue()); //16
      formData.append('masterJob', masterJobRef.current.getInputValue()); //17
      formData.append(
        'masterQualification',
        masterQualificationRef.current.getInputValue()
      ); //18
      if (isSocial) {
        formData.append('city', cityRef.current.getInputValue()); //19
        formData.append('brothersNum', brothersNumRef.current.getInputValue()); //20
        formData.append(
          'brothersMaleNum',
          brothersMaleNumRef.current.getInputValue()
        ); //21
        formData.append(
          'brothersFemaleNum',
          brothersFemaleNumRef.current.getInputValue()
        ); //22
        formData.append(
          'brothersOrder',
          brothersOrderRef.current.getInputValue()
        ); //23
        formData.append('income', incomeRef.current.getInputValue()); //24
        formData.append('motherName', motherNameRef.current.getInputValue()); //25
        formData.append(
          'motherNationality',
          motherNationalityRef.current.getInputValue()
        ); //26
        formData.append('motherJob', motherJobRef.current.getInputValue()); //27
        formData.append(
          'motherMobile',
          motherMobileRef.current.getInputValue()
        ); //28
        formData.append(
          'fatherNationality',
          fatherNationalityRef.current.getInputValue()
        ); //29
        formData.append(
          'fatherMobile',
          fatherMobileRef.current.getInputValue()
        ); //30
      }

      // photos
      const arrayOfPhotos = [];
      if (frontIdCard.size !== '0') {
        // check on the type if it is not an image then return and dispatch error
        if (!frontIdCard.type.includes('image')) {
          dispatchDashboardStates({
            type: 'ERROR',
            errorMessage:
              'برجاء ادخال صورة البطاقة من الامام في صيغة صورة وليس ملف',
          });
          return;
        }
        const photoType = 'frontIdCard';
        const photo = new File(
          [frontIdCard],
          `${encodeURIComponent(frontIdCard.name)}@-@-@${photoType}`,
          { type: frontIdCard.type }
        );
        arrayOfPhotos.push(photo);
      }
      if (backIdCard.size !== '0') {
        // check on the type if it is not an image then return and dispatch error
        if (!backIdCard.type.includes('image')) {
          dispatchDashboardStates({
            type: 'ERROR',
            errorMessage:
              'برجاء ادخال صورة البطاقة من الخلف في صيغة صورة وليس ملف',
          });
          return;
        }
        const photoType = 'backIdCard';
        const photo = new File(
          [backIdCard],
          `${encodeURIComponent(backIdCard.name)}@-@-@${photoType}`,
          { type: backIdCard.type }
        );
        arrayOfPhotos.push(photo);
      }
      if (birthCertificate.size !== '0') {
        // check on the type if it is not an image then return and dispatch error
        if (!birthCertificate.type.includes('image')) {
          dispatchDashboardStates({
            type: 'ERROR',
            errorMessage:
              'برجاء ادخال صورة شهادة الميلاد في صيغة صورة وليس ملف',
          });
          return;
        }
        const photoType = 'birthCertificate';
        const photo = new File(
          [birthCertificate],
          `${encodeURIComponent(birthCertificate.name)}@-@-@${photoType}`,
          { type: birthCertificate.type }
        );
        arrayOfPhotos.push(photo);
      }
      if (personalPhoto.size !== '0') {
        // check on the type if it is not an image then return and dispatch error
        if (!personalPhoto.type.includes('image')) {
          dispatchDashboardStates({
            type: 'ERROR',
            errorMessage: 'برجاء ادخال صورة شخصية في صيغة صورة وليس ملف',
          });
          return;
        }
        const photoType = 'personalPhoto';
        const photo = new File(
          [personalPhoto],
          `${encodeURIComponent(personalPhoto.name)}@-@-@${photoType}`,
          { type: personalPhoto.type }
        );
        arrayOfPhotos.push(photo);
      }
      if (secondarySchoolCertificate.size !== '0') {
        // check on the type if it is not an image then return and dispatch error
        if (!secondarySchoolCertificate.type.includes('image')) {
          dispatchDashboardStates({
            type: 'ERROR',
            errorMessage:
              'برجاء ادخال صورة شهادة الثانوية العامة في صيغة صورة وليس ملف',
          });
          return;
        }
        const photoType = 'secondarySchoolCertificate';
        const photo = new File(
          [secondarySchoolCertificate],
          `${encodeURIComponent(
            secondarySchoolCertificate.name
          )}@-@-@${photoType}`,
          { type: secondarySchoolCertificate.type }
        );
        arrayOfPhotos.push(photo);
      }
      if (nominationCard.size !== '0') {
        // check on the type if it is not an image then return and dispatch error
        if (!nominationCard.type.includes('image')) {
          dispatchDashboardStates({
            type: 'ERROR',
            errorMessage:
              'برجاء ادخال صورة  بطاقة الترشيح في صيغة صورة وليس ملف',
          });
          return;
        }
        const photoType = 'nominationCard';
        const photo = new File(
          [nominationCard],
          `${encodeURIComponent(nominationCard.name)}@-@-@${photoType}`,
          { type: nominationCard.type }
        );
        arrayOfPhotos.push(photo);
      }
      // append photos
      for (var i = 0; i < arrayOfPhotos.length; i++) {
        formData.append('photos', arrayOfPhotos[i]);
      }
      // send data
      const response = await completeStudentDataService(formData, id);
      if (response.status === 'success') {
        dispatchDashboardStates({
          type: 'SUCCESS',
          successMessage: 'تم استكمال البيانات بنجاح',
        });
        // navigate  after 2 seconds
        setTimeout(() => {
          navigate('/dashboard/formsDownload');
        }, 2000);
      } else {
        dispatchDashboardStates({
          type: 'ERROR',
          errorMessage: response.message,
        });
      }
    }
  };

  return (
    <Fragment>
      {<NavHeader title={'استكمال بيانات الطالب'} mode={'title'} />}
      <div className={styles['container']}>
        {
          <div className={styles['inner-container']}>
            <form className={styles['inputs-form']} onSubmit={enterDataHandler}>
              <div className={styles['inputs-nav']}>
                <h2>بيانات الطالب</h2>
              </div>
              <div className={styles['inputs-container']}>
                <div className={styles['part']}>
                  <div className={styles['input-fields']}>
                    <Input
                      title={'الاسم باللغة الانجليزية رباعى'}
                      ref={studentNameEnRef}
                    />
                    <Input title={'رقم موبيل'} ref={secondPhoneNumberRef} />
                    <Input title={'تليفون المنزل'} ref={homeTelRef} />
                    {isSocial && (
                      <Input title={'المدينة / المركز'} ref={cityRef} />
                    )}
                    <Input title={'العنوان'} ref={addressRef} />
                    <Input title={'البريد الالكتروني'} ref={emailRef} />
                  </div>
                </div>
                <div className={styles['part']}>
                  <div className={styles['input-fields']}>
                    <Input title={'المؤهل الدراسي'} ref={qualificationRef} />
                    <h2>سنة الحصول على المؤهل </h2>
                    <div className={styles['years-parts']}>
                      <Input
                        ref={yearPart2Ref}
                        wd={'sm'}
                        placeholder={new Date().getFullYear() - 1}
                      />
                      /
                      <Input
                        ref={yearPart1Ref}
                        wd={'sm'}
                        placeholder={new Date().getFullYear()}
                      />
                    </div>
                    <Input
                      title={'المجموع الكلي'}
                      type={'number'}
                      ref={totalGradeRef}
                      step='any'
                    />
                    <Input
                      title={'النسبة المئوية'}
                      type={'number'}
                      ref={percentageRef}
                      step='any'
                    />
                  </div>
                </div>
                {isTourism && (
                  <div className={styles['part']}>
                    <div className={styles['input-fields']}>
                      {' '}
                      <h2>البرنامج الاول</h2>
                      <select
                        ref={programRef1}
                        className={styles['select']}
                        onChange={() => setProgram1(programRef1.current.value)}
                      >
                        <option value=''>اختر البرنامج</option>
                        {tourismPrograms1 &&
                          tourismPrograms1.length !== 0 &&
                          tourismPrograms1.map((el) => (
                            <option value={el} key={`${el}_program1`}>
                              {el}
                            </option>
                          ))}
                      </select>
                      <h2>البرنامج الثانى</h2>
                      <select
                        ref={programRef2}
                        className={styles['select']}
                        onChange={() => setProgram2(programRef2.current.value)}
                      >
                        <option value=''>اختر البرنامج</option>
                        {tourismPrograms2 &&
                          tourismPrograms2.length !== 0 &&
                          tourismPrograms2.map((el) => (
                            <option value={el} key={`${el}_program2`}>
                              {el}
                            </option>
                          ))}
                      </select>
                      <h2>البرنامج الثالث</h2>
                      <select
                        ref={programRef3}
                        className={styles['select']}
                        onChange={() => setProgram3(programRef3.current.value)}
                      >
                        <option value=''>اختر البرنامج</option>
                        {tourismPrograms3 &&
                          tourismPrograms3.length !== 0 &&
                          tourismPrograms3.map((el) => (
                            <option value={el} key={`${el}_program3`}>
                              {el}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                )}
                {isSocial && (
                  <div className={styles['part']}>
                    <div className={styles['input-fields']}>
                      <Input
                        title={'عدد الاخوة'}
                        type={'number'}
                        ref={brothersNumRef}
                      />
                      <Input
                        title={'عدد  الذكور'}
                        type={'number'}
                        ref={brothersMaleNumRef}
                      />
                      <Input
                        title={'عدد  الاناث'}
                        type={'number'}
                        ref={brothersFemaleNumRef}
                      />
                      <Input
                        title={'ترتيبك بين الاخوة'}
                        type={'number'}
                        ref={brothersOrderRef}
                      />
                      <Input
                        title={'الدخل الشهري للأسرة'}
                        type={'number'}
                        ref={incomeRef}
                        step='any'
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className={styles['inputs-container']}>
                <div className={styles['part']}>
                  <div className={styles['inputs-nav-small']}>
                    <h2>بيانات ولي الامر</h2>
                  </div>
                  <div className={styles['input-fields']}>
                    <Input title={'اسم ولي الامر'} ref={masterNameRef} />
                    <Input title={'وظيفة ولي الامر'} ref={masterJobRef} />
                    <Input
                      title={'المؤهل الدراسي لولي الامر'}
                      ref={masterQualificationRef}
                    />
                  </div>
                </div>
                <div className={styles['part']}>
                  <div className={styles['inputs-nav-small']}>
                    <h2>بيانات الاب</h2>
                  </div>
                  <div className={styles['input-fields']}>
                    <Input title={'اسم الاب'} ref={fatherNameRef} />
                    {isSocial && (
                      <Input title={'الجنسية'} ref={fatherNationalityRef} />
                    )}
                    <Input
                      title={isSocial ? 'الوظيفة' : 'وظيفة الاب'}
                      ref={fatherJobRef}
                    />
                    {isSocial && (
                      <Input title={'الموبيل'} ref={fatherMobileRef} />
                    )}
                    <Input
                      title={'المؤهل الدراسي للأب'}
                      ref={fatherQualificationRef}
                    />
                  </div>
                </div>
                {!isSocial && (
                  <div className={styles['part']}>
                    <div className={styles['inputs-nav-small']}>
                      <h2 style={{ color: '#19355a', userSelect: 'none' }}>
                        بيانات
                      </h2>
                    </div>
                  </div>
                )}
                {isSocial && (
                  <div className={styles['part']}>
                    <div className={styles['inputs-nav-small']}>
                      <h2>بيانات الام</h2>
                    </div>
                    <div className={styles['input-fields']}>
                      <Input title={'اسم الام'} ref={motherNameRef} />
                      <Input title={'الجنسية'} ref={motherNationalityRef} />
                      <Input title={'الوظيفة'} ref={motherJobRef} />
                      <Input title={'الموبيل'} ref={motherMobileRef} />
                    </div>
                  </div>
                )}
              </div>
              <div className={styles['inputs-nav']}>
                <h2>رفع الملفات</h2>
              </div>
              <div className={styles['inputs-container']}>
                <div className={styles['part']}>
                  <div className={styles['input-fields']}>
                    <div className={styles['form-control']}>
                      <input
                        type='file'
                        name='frontCard'
                        id='frontCard'
                        className={styles['inputfile']}
                        dir='ltr'
                        accept='image/png, image/jpeg, image/jpg'
                        onChange={async (e) => {
                          setFrontIdCardState(true);
                          const imageFile = e.target.files[0];
                          try {
                            const compressedFile = await imageCompression(
                              imageFile,
                              compressOptiopns
                            );
                            setFrontIdCard(compressedFile);
                            setFrontIdCardState(false);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      />
                      <div className={styles['upload-btn']}>
                        <h3 htmlFor='frontCard'>
                          صورة البطاقة الشخصية من الامام
                        </h3>
                        <div>
                          <label htmlFor='frontCard'>
                            {frontIdCardState ? (
                              <CircularProgress
                                size={20}
                                sx={{
                                  color: '#a18a00',
                                }}
                              />
                            ) : (
                              'اختر ملف'
                            )}
                          </label>
                          <p>
                            {frontIdCard && frontIdCard.name !== ''
                              ? frontIdCard.name
                              : 'لم يتم اختيار ملف'}
                          </p>
                        </div>
                      </div>
                      <input
                        type='file'
                        name='backCard'
                        id='backCard'
                        className={styles['inputfile']}
                        dir='ltr'
                        accept='image/png, image/jpg, image/jpeg'
                        onChange={async (e) => {
                          setBackIdCardState(true);
                          const imageFile = e.target.files[0];
                          try {
                            const compressedFile = await imageCompression(
                              imageFile,
                              compressOptiopns
                            );
                            setBackIdCard(compressedFile);
                            setBackIdCardState(false);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      />
                      <div className={styles['upload-btn']}>
                        <h3 htmlFor='backCard'>
                          صورة البطاقة الشخصية من الخلف
                        </h3>
                        <div>
                          <label htmlFor='backCard'>
                            {backIdCardState ? (
                              <CircularProgress
                                size={20}
                                sx={{
                                  color: '#a18a00',
                                }}
                              />
                            ) : (
                              'اختر ملف'
                            )}
                          </label>
                          <p>
                            {backIdCard && backIdCard.name !== ''
                              ? backIdCard.name
                              : 'لم يتم اختيار ملف'}
                          </p>
                        </div>
                      </div>
                      <input
                        type='file'
                        name='birthCertificate'
                        id='birthCertificate'
                        className={styles['inputfile']}
                        dir='ltr'
                        accept='image/png, image/jpg, image/jpeg'
                        onChange={async (e) => {
                          setBirthCertificateState(true);
                          const imageFile = e.target.files[0];

                          try {
                            const compressedFile = await imageCompression(
                              imageFile,
                              compressOptiopns
                            );
                            setBirthCertificate(compressedFile);
                            setBirthCertificateState(false);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      />
                      <div className={styles['upload-btn']}>
                        <h3 htmlFor='birthCertificate'>شهادة الميلاد</h3>
                        <div>
                          <label htmlFor='birthCertificate'>
                            {birthCertificateState ? (
                              <CircularProgress
                                size={20}
                                sx={{
                                  color: '#a18a00',
                                }}
                              />
                            ) : (
                              'اختر ملف'
                            )}
                          </label>
                          <p>
                            {birthCertificate && birthCertificate.name !== ''
                              ? birthCertificate.name
                              : 'لم يتم اختيار ملف'}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles['part']}>
                  <div className={styles['input-fields']}>
                    <div className={styles['form-control']}>
                      <input
                        type='file'
                        name='personalPhoto'
                        id='personalPhoto'
                        className={styles['inputfile']}
                        dir='ltr'
                        accept='image/png, image/png, image/jpeg'
                        onChange={async (e) => {
                          setPersonalPhotoState(true);
                          const imageFile = e.target.files[0];

                          try {
                            const compressedFile = await imageCompression(
                              imageFile,
                              compressOptiopns
                            );
                            setPersonalPhoto(compressedFile);
                            setPersonalPhotoState(false);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      />
                      <div className={styles['upload-btn']}>
                        <h3 htmlFor='personalPhoto'>صورة شخصية</h3>
                        <div>
                          <label htmlFor='personalPhoto'>
                            {personalPhotoState ? (
                              <CircularProgress
                                size={20}
                                sx={{
                                  color: '#a18a00',
                                }}
                              />
                            ) : (
                              'اختر ملف'
                            )}
                          </label>
                          <p>
                            {personalPhoto && personalPhoto.name !== ''
                              ? personalPhoto.name
                              : 'لم يتم اختيار ملف'}
                          </p>
                        </div>
                      </div>
                      <input
                        type='file'
                        name='secondarySchoolCertificate'
                        id='secondarySchoolCertificate'
                        className={styles['inputfile']}
                        dir='ltr'
                        accept='image/png, image/png, image/jpeg'
                        onChange={async (e) => {
                          setSecondarySchoolCertificateState(true);
                          const imageFile = e.target.files[0];
                          try {
                            const compressedFile = await imageCompression(
                              imageFile,
                              compressOptiopns
                            );
                            setSecondarySchoolCertificate(compressedFile);
                            setSecondarySchoolCertificateState(false);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      />
                      <div className={styles['upload-btn']}>
                        <h3 htmlFor='secondarySchoolCertificate'>
                          شهادة الثانوية العامة
                        </h3>
                        <div>
                          <label htmlFor='secondarySchoolCertificate'>
                            {secondarySchoolCertificateState ? (
                              <CircularProgress
                                size={20}
                                sx={{
                                  color: '#a18a00',
                                }}
                              />
                            ) : (
                              'اختر ملف'
                            )}
                          </label>
                          <p>
                            {secondarySchoolCertificate &&
                            secondarySchoolCertificate.name !== ''
                              ? secondarySchoolCertificate.name
                              : 'لم يتم اختيار ملف'}
                          </p>
                        </div>
                      </div>
                      <input
                        type='file'
                        name='nominationCard'
                        id='nominationCard'
                        className={styles['inputfile']}
                        dir='ltr'
                        accept='image/png, image/png, image/jpeg'
                        onChange={async (e) => {
                          setNominationCardState(true);
                          const imageFile = e.target.files[0];
                          try {
                            const compressedFile = await imageCompression(
                              imageFile,
                              compressOptiopns
                            );
                            setNominationCard(compressedFile);
                            setNominationCardState(false);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      />
                      <div className={styles['upload-btn']}>
                        <h3 htmlFor='nominationCard'>بطاقة الترشيح</h3>
                        <div>
                          <label htmlFor='nominationCard'>
                            {nominationCardState ? (
                              <CircularProgress
                                size={20}
                                sx={{
                                  color: '#a18a00',
                                }}
                              />
                            ) : (
                              'اختر ملف'
                            )}
                          </label>
                          <p>
                            {nominationCard && nominationCard.name !== ''
                              ? nominationCard.name
                              : 'لم يتم اختيار ملف'}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {!dashboardStates.pending && (
                <button className={styles['btn']}>ادخل البيانات</button>
              )}
              {dashboardStates.pending && (
                <button className={styles['btn']}>
                  <CircularProgress
                    size={20}
                    sx={{
                      color: '#a18a00',
                    }}
                  />
                </button>
              )}
            </form>
          </div>
        }

        {dashboardStates.pending && (
          <Message text={'يتم الان معالجة البيانات'} type='load' />
        )}
      </div>
      {/* ********** SUCCESS SNACKBAR ********** */}
      <Snackbar
        open={dashboardStates.success}
        onClose={handleCloseSnackbar}
        autoHideDuration={2000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Alert
          severity='success'
          onClose={handleCloseSnackbar}
          dir='ltr'
          sx={{
            width: '100%',
            backgroundColor: '#43A047',
            color: '#fff',
            fontSize: '1.4rem',
            '& .MuiAlert-icon': {
              color: '#fff',
            },
          }}
        >
          !{dashboardStates.successMessage}
        </Alert>
      </Snackbar>
      {/* ********** ERROR SNACKBAR ********** */}
      <Snackbar
        open={dashboardStates.error}
        onClose={handleCloseSnackbar}
        autoHideDuration={20000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Alert
          severity='error'
          onClose={handleCloseSnackbar}
          dir='ltr'
          sx={{
            width: '100%',
            backgroundColor: '#D32F2F',
            color: '#fff',
            fontSize: '1.4rem',
            '& .MuiAlert-icon': {
              color: '#fff',
            },
          }}
        >
          !{dashboardStates.errorMessage}
        </Alert>
      </Snackbar>
    </Fragment>
  );
});

export { StudentDataEnter };
